import { gql } from '@apollo/client';

export const ATTENDANCE_INCIDENTS = gql`
  query AttendanceIncidents(
    $filter: AttendanceIncidentsFilterInput!
    $sort: [AttendanceIncidentsSortInput!]
  ) {
    attendanceIncidents(filter: $filter, sort: $sort) {
      count
      data {
        id
        employee {
          id
          firstName
          email
          lastName
        }
        excusedCount
        isArchived
        month
        year
        behaviourKey
        rawCount
        effectiveCount
        scoreImpact
        reason
        loggedAt
        loggedByUser {
          firstName
          lastName
        }
      }
    }
  }
`;

export const TEAM_ATTENDANCE = gql`
  query TeamAttendance(
    $filter: TeamAttendanceFilterInput!
    $sort: [TeamAttendanceSortInput!]
  ) {
    teamAttendance(filter: $filter, sort: $sort) {
      count
      data {
        employeeId
        employee {
          firstName
          email
          id
          lastName
          level {
            id
            name
            description
          }
        }
        quarter
        month
        year
        score
        incidents {
          id
          behaviourKey
          rawCount
          excusedCount
          effectiveCount
        }
        leave {
          effectiveCount
          excusedCount
          rawCount
        }
        wfhOver {
          effectiveCount
          excusedCount
          rawCount
        }
        hoursOver {
          effectiveCount
          excusedCount
          rawCount
        }
        late {
          effectiveCount
          excusedCount
          rawCount
        }
        early {
          effectiveCount
          excusedCount
          rawCount
        }
        standup {
          effectiveCount
          excusedCount
          rawCount
        }
        xbrk {
          effectiveCount
          excusedCount
          rawCount
        }
        sbrk {
          effectiveCount
          excusedCount
          rawCount
        }
        quarterlyBreakdown {
          quarter
          quarterLabel
          year
          score
          leave {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          wfhOver {
            rawCount

            excusedCount
            effectiveCount
          }
          hoursOver {
            rawCount

            excusedCount
            effectiveCount
          }
          late {
            rawCount

            excusedCount
            effectiveCount
          }
          early {
            rawCount

            excusedCount
            effectiveCount
          }
          standup {
            rawCount

            excusedCount
            effectiveCount
          }
          xbrk {
            rawCount

            excusedCount
            effectiveCount
          }
          sbrk {
            rawCount

            excusedCount
            effectiveCount
          }
          incidents {
            rawCount

            excusedCount
            effectiveCount
          }
        }
        monthlyBreakdown {
          month
          monthName
          quarter
          year
          score
          leave {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          wfhOver {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          hoursOver {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          late {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          early {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          standup {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          xbrk {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          sbrk {
            rawCount
            excusedCount
            overLimitCount
            effectiveCount
          }
          incidents {
            rawCount
            excusedCount
            effectiveCount
          }
        }
      }
    }
  }
`;

export const TEAMS_QUATRES = gql`
  query EmployeeTenureQuarters {
    employeeTenureQuarters {
      quarter
    }
  }
`;

export const ATTENDANCE_SCORE = gql`
  query AttendanceScore($where: AttendanceScoreWhereInput!) {
    attendanceScore(where: $where) {
      data {
        employeeId
        employee {
          email
          firstName
          id
          lastName
        }
        month
        year
        score
        breakdown {
          leave {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
          wfhOver {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
          hoursOver {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
          late {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
          early {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
          standup {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
          xbrk {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
          sbrk {
            rawCount
            excusedCount
            effectiveCount
            deduction
          }
        }
        incidents {
          id
          employeeId
          month
          year
          behaviourKey
          rawCount
          excusedCount
          effectiveCount
          excuseReason
          excusedBy
          excusedAt
          loggedBy
          loggedAt
          createdAt
        }
      }
    }
  }
`;

export const MY_ATTENDANCE_INCIDENTS = gql`
  query MyAttendanceIncidents(
    $filter: MyAttendanceIncidentsFilterInput!
    $sort: [AttendanceIncidentsSortInput!]
  ) {
    myAttendanceIncidents(filter: $filter, sort: $sort) {
      count
      data {
        id
        employeeId
        employee {
          email
          firstName
          id
          lastName
        }
        month
        year
        behaviourKey
        rawCount
        excusedCount
        effectiveCount
        excuseReason
        excusedBy
        excusedByUser {
          email
          firstName
          id
          lastName
        }
        excusedAt
        loggedBy
        loggedByUser {
          email
          firstName
          id
          lastName
        }
        loggedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const PODS = gql`
  query PodsAttendanceTracker($filters: PodFiltersInput) {
    pods(filters: $filters) {
      pods {
        id
        name
        podLeadId
        podLead {
          id
          firstName
          lastName
        }
      }
      count
    }
  }
`;

export const USERS_LISTING = gql`
  query UsersAdminAttendanceLog($filters: AdminSearchInput) {
    usersAdminAttendanceLog(filters: $filters) {
      count
      users {
        id
        email
        firstName
        lastName
        tenureQuarters {
          isCurrent
          quarter
          rangeFrom {
            month
            year
          }
          rangeTo {
            month
            year
          }
        }
      }
    }
  }
`;

export const USER_ATTENDANCE = gql`
  query UserAttendance(
    $filter: UserAttendanceFilterInput!
    $sort: [TeamAttendanceSortInput!]
  ) {
    userAttendance(filter: $filter, sort: $sort) {
      data {
        employeeId
        employee {
          id
          firstName
          lastName
        }
        periodFrom
        periodTo
        score
        monthlyBreakdown {
          month
          monthName
          isCompleted
          quarter
          year
          periodFrom
          periodTo
          score
          leave {
            rawCount
            excusedCount
            effectiveCount
          }
          wfhOver {
            rawCount
            excusedCount
            effectiveCount
          }
          hoursOver {
            rawCount
            excusedCount
            effectiveCount
          }
          late {
            rawCount
            excusedCount
            effectiveCount
          }
          early {
            rawCount
            excusedCount
            effectiveCount
          }
          standup {
            rawCount
            excusedCount
            effectiveCount
          }
          xbrk {
            rawCount
            excusedCount
            effectiveCount
          }
          sbrk {
            rawCount
            excusedCount
            effectiveCount
          }
        }
      }
    }
  }
`;

export const INCIDENT_DETAIL = gql`
  query GetIncidentDetails($where: AttendanceIncidentWhereUniqueInput!) {
    getIncidentDetails(where: $where) {
      data {
        id
        employeeId
        month
        year
        behaviourKey
        reason
        isArchived
        archiveReason
        isExcused
        excuseReason
        employee {
          id
          firstName
          lastName
          email
          department {
            name
          }
          level {
            name
          }
        }
        archivedByUser {
          firstName
          id
          lastName
          email
          archivedAt
        }
        loggedByUser {
          id
          firstName
          email
          loggedAt
          createdAt
        }
        excusedByUser {
          id
          firstName
          email
          excusedAt
        }
        deletedAt
      }
    }
  }
`;

export const INCIDENT_LOG_SUMMARY = gql`
  query AttendanceIncidentSummary(
    $where: AttendanceIncidentSummaryWhereInput!
  ) {
    attendanceIncidentSummary(where: $where) {
      summary
    }
  }
`;
